import React, { useEffect, useRef, useState } from "react";
import "./Product.css";

const CaisseAmericaine = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    "/images/caisse_americaine/1.jpg",
    "/images/caisse_americaine/2.jpg",
    "/images/caisse_americaine/3.jpg",
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product light-blue-bg" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? "fade-in" : ""}`}>
            <h2 className="product-title">Caisse Americaine</h2>
            <p>
              Idéale pour transporter ou stocker vos produits lourds et
              volumineux, la caisse américaine (ou FEFCO 0201 en cannelure) sera
              parfaite pour protéger vos produits.
              <br /><br/>
              La caisse américaine est également l'emballage parfait pour vos
              produits fragiles souvent déjà emballés. Cet emballage est idéal
              pour optimiser vos surfaces de stockage. Il répond également
              parfaitement aux contraintes de transport. Connue et reconnue de
              tous, la caisse américaine résiste aux chocs, aux longs trajets,
              aux changements de températures. Son efficacité n'est plus à
              prouver, elle est utilisée partout et par tous. Livrée collée à
              plat, son montage est très facile. Sur-mesure et 100 %
              personnalisable, Vous êtes libre de choisir le format, la
              quantité, votre support, et votre design.
              <br />
              Support : micro ondulé ;simple ondulation ou double ondulation .
            </p>
          </div>

          {/* Image Gallery */}
          <div
            className={`product-gallery ${isVisible ? "fade-in-delay" : ""}`}
          >
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaisseAmericaine;
